import React from 'react';
import '../css/modalPerfil.css';
import Badge from './Badge';

function DatosPerfil(props) {

    return (
        <>

            <div className='container pb-3  ' id={props.isEditar ? "datosMiPerfil0" : "datosMiPerfil1"}>
                <div className=' pb-5 px-2'>
                    <div className='row pb-3'>
                        <p className='letraDatosPerfil'>{props.perfil.descripcion}</p>
                    </div>
                    <h3 className='letraTituloPerfil py-3 mb-0 '>Datos de la empresa:</h3>
                    <div className='row mt-3 mb-5 letraDatosPerfil py-3 px-4 mx-0 datosEmpresa'>
                        <p className='borderBotRepresentante py-3 py-0 mb-0'><span className='tituloDatoPerfil'>Razón social: </span> {props.perfil.nombre}</p>
                        {props.esAdmin ?
                            <>
                                <p className='borderBotRepresentante py-3 py-0 mb-0'><span className='tituloDatoPerfil'>Cuit: </span> {props.perfil.cuit}</p>
                                <p className='borderBotRepresentante py-3 py-0 mb-0'><span className='tituloDatoPerfil'>Unión asociada: </span> {props.perfil.union}</p>
                            </>
                            :
                            <></>
                        }
                        <p className='borderBotRepresentante py-3 mb-0'><span className='tituloDatoPerfil'>Dirección: </span>
                            {props.perfil.calle + " " + props.perfil.altura + ", " + props.perfil.localidad}
                        </p>
                        <p className='borderBotRepresentante py-3 mb-0'>
                            <span className='tituloDatoPerfil'>Rubros: </span>
                            {props.perfil.rubros.length !== 0 ?
                                props.perfil.rubros.map(function (rubro, i) {
                                    return (
                                        i == 0 ?
                                            rubro
                                            :
                                            " / " + rubro
                                    )
                                })
                                :
                                <></>
                            }
                        </p>
                        <p className='borderBotRepresentante py-3 mb-0'><span className='tituloDatoPerfil'>Página web: </span>{props.perfil.paginaWeb}</p>
                        <p className='borderBotRepresentante py-3 mb-0'><span className='tituloDatoPerfil'>Email: </span>{props.perfil.email}</p>
                        <p className='py-3 mb-0'><span className='tituloDatoPerfil'>Teléfono: </span> {props.perfil.numeroDeTelefono}</p>
                    </div>
                    {props.perfil.productosOfrecidos.length !== 0 && props.perfil.productosOfrecidos[0] != "" ?
                        <>
                            <h3 className='letraTituloPerfil pb-3'>Nuestros productos:</h3>
                            {
                                props.perfil.productosOfrecidos.map(function (producto) {
                                    return (
                                        <Badge text={producto} />
                                    )
                                })
                            }
                        </>
                        : props.esAdmin ?
                            <>
                                <h3 className='letraTituloPerfil pb-3'>Nuestros productos:</h3>
                                <p className='mt-1'>No se encontraron productos</p>
                            </>
                            :
                            <></>

                    }
                    {props.esAdmin ?
                        <>
                            <h3 className='letraTituloPerfil pb-3 pt-4'>Nuestros productos demandados:</h3>
                            {props.perfil.productosDemandados.length !== 0 && props.perfil.productosDemandados[0] != "" ?
                                <>
                                    {
                                        props.perfil.productosDemandados.map(function (producto) {
                                            return (
                                                <Badge text={producto} />
                                            )
                                        })
                                    }
                                </>
                                :
                                <p className='mt-1'>No se encontraron productos</p>
                            }
                        </>
                        :
                        <>
                        </>

                    }
                </div>
            </div>



        </>

    );
}


export default DatosPerfil;